export default {
  ccv_title: '年龄确认',
  ccv_birthDate: '出生年月',
  ccv_day: '日',
  ccv_month: '月',
  ccv_year: '年',
  ccv_privacyNote:
    '您的年龄信息仅用于登录认证，我们将不会存储此信息，国家和年龄信息一经确认无法更正',
  ccv_readCarefully: '请仔细阅读',
  ccv_agreeTerms: '我已经详读并同意${terms}',
  ccv_agreeAll: '全部同意',
  ccv_continue: '继续',
  ccv_parentConsent:
    '我们需要向您的父母或法定监护人获取同意才能允许您继续访问；',
  ccv_deviceToParent:
    '请将您的设备提供给您的父母或者法定监护人，我们将通过几个简单的步骤获取他们的同意',
  ccv_agreeGame: '同意继续游戏',
  ccv_agreeGameAndAds: '同意继续游戏并同步数据至第三方广告平台',
  ccv_guardianConfirm: '未成年人家长/监护人确认',
  ccv_termsOfService: '服务条款',
  ccv_privacyPolicy: '隐私政策',
  ccv_guardian: '美国家长同意书',
  ccv_nextTime: '下次',
  ccv_checkAgreement: '请您勾选并同意协议内容，才能继续游戏',
  ccv_selectBirthDate: '请选择出生年月日',
  ccv_protectPay:
    '为了保护此交易，我们将启动一美元预授权扣款。此交易不会有任何实际扣款。请立即操作'
};
